/* eslint-disable no-use-before-define */
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';

export default class TpAdminItem {
  constructor(item) {
    if (item === undefined) {
      this.TpAdminId = '';
      this.ThirdPartyAdminId = '';
      this.ThirdPartyAdminName = '';
      this.ThirdPartyAdminEmail = '';
      this.ThirdPartyIsActive = '';
      this.ThirdPartySource = '';
      return;
    }
    this.TpAdminId = item.tpAdminId;
    this.ThirdPartyAdminId = item.thirdPartyAdminId;
    this.ThirdPartyAdminName = item.thirdPartyAdminName;
    this.ThirdPartyAdminEmail = item.thirdPartyAdminEmail;
    this.ThirdPartyIsActive = item.thirdPartyIsActive;
    this.ThirdPartySource = item.thirdPartySource;
  }

  static NameOfTheIdField() {
    return 'TpAdminId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];
  static BoolFields = ['ThirdPartyIsActive'];

  static nameOfTheItemDetailList(item) {
    return `${item.ThirdPartyAdminId} - ${item.ThirdPartyAdminName}`;
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      {
        label: 'Id',
        orderById: 'TpAdminId',
        data: 'TpAdminId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Third-Party Admin Id',
        orderById: 'ThirdPartyAdminId',
        data: 'ThirdPartyAdminId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartyAdminName',
        data: 'ThirdPartyAdminName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Email',
        orderById: 'ThirdPartyAdminEmail',
        data: 'ThirdPartyAdminEmail',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Is Active',
        orderById: 'ThirdPartyIsActive',
        data: (item) => JsxHelper.YesNo(item.ThirdPartyIsActive),
        type: FieldTypesEnum.BoolFields,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "TpAdminId", label: "Id", className: "text-left" },
        { name: "ThirdPartyAdminId", label: "Third-Party Admin Id", className: "text-left" },
        { name: "ThirdPartyAdminName", label: "Name", className: "text-left" },
        { name: "ThirdPartyAdminEmail", label: "Email", className: "text-left" },
        { name: (item) => JsxHelper.YesNo(item.ThirdPartyIsActive), label: "Is Active", className: "text-left" },
        { name: "ThirdPartySource", label: "Source", className: "text-left" },
      ],
    },
  ];
}
